"use client";

import { ErrorState } from "@aio/platform-ui";

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  const digest = (error as Error & { digest?: string }).digest;
  return (
    <div className="mx-auto max-w-2xl p-10">
      <ErrorState
        description={error.message}
        onRetry={reset}
        {...(digest ? { traceId: digest } : {})}
      />
    </div>
  );
}
